import { render, staticRenderFns } from "./WorkResult.html?vue&type=template&id=decb4396&external"
import script from "./WorkResult.ts?vue&type=script&lang=ts&external"
export * from "./WorkResult.ts?vue&type=script&lang=ts&external"
import style0 from "./WorkResult.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports